<template>
  <div id="head">
    <common-header></common-header>

    <div class="line">
      <nav>
        <div class="top l">
          <router-link to="/home">
            <img class="logo" :src="URL+logo_name"/>
          </router-link>
          <div class="middle">
            <div class="inp">
              <span class="dianpu">
                <el-dropdown size="small" @command="handleCommand">
                  <span class="el-dropdown-link">
                    {{currentSearch}}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(value, i) in searchType"
                      :key="i"
                      :command="i"
                    >{{value}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </span>
              <input type="text" v-model="search_value" @keyup.enter="search">
              <span class="search" @click="search">搜索</span>
            </div>
            <ul>
              <li v-for="(value,index) in keyWords" :key="index">
                <a @click="hotSearch(value)">{{value.hot_words}}</a>
              </li>
            </ul>
          </div>
          <div class="dropdown-content r">
            <my-shopping-cart></my-shopping-cart>
          </div>
        </div>
        <div class="bottom l">
          <div class="all l" @mouseover="showClass" @mouseleave="hideClass" @click="ctrlClass">
            <div class="all-class-ctrl" @click="$router.push({path:'/allGoods'})">
              <img class="jiazai" src="../assets/img/all.jpg">
              <span class="shangpin">全部商品分类</span>
            </div>
            <div class="nav-class" v-show="showClassNav" @mouseleave="hideClass">
              <ul class="allul l">
                <li
                  @click="GoTo(item)"
                  class="li"
                  v-for="(item, index) in iTem"
                  @mouseover="mouseover(item,index,1)"
                  :key="item.id"
                >
                  <img src="../assets/img/header-ionic.jpg">
                  <a>{{item.class_name}}</a>
                  <i class="el-icon-arrow-right"></i>
                </li>
              </ul>
              <div class="banner-image-box">
                <div class="allul-child">
                  <ul class="show">
                    <li class="li-class2" v-for="(item2,i) in condata" :key="i">
                      <p
                        @mouseover="mouseover(item2,i,2)"
                        @click="GoTo(item2)"
                        :key="item2.id"
                      >{{item2.class_name}}</p>
                    </li>
                  </ul>
                  <ul class="show3">
                    <li
                      @click="GoTo(item3)"
                      class="li-class3"
                      v-for="(item3,i) in condata2"
                      :key="i"
                    >
                      <p>{{item3.class_name}}</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <ul class="navul">
            <li v-for="(item,index) in items" :key="index">
              <!-- {{arr[index][1] == item.link.substr(22).match(arr[index][1])}} -->
              <a @click="toLink(item,index)" :class="{active:index == off}">{{item.nav_titile}}</a>
              <!-- {{~~item.link.match(`currentId=${index}`)[0].match(/\d+/g)}} -->
              <!-- <a :href="item.link">{{item.nav_titile}}</a> -->
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>
<script>
import Qs from "qs";
export default {
  data() {
    return {
      off:0,
      all: false,
      no: true,
      ok: false,
      items: [],
      arr: [
        ["首页", "home"],
        ["抢购", "chase"],
        ["品牌", "brand"],
        ["店铺", "store"],
        ["皇家御饮", "royaldrink"],
        ["御贡赠品", "gift"],
        ["滋补养身", "yangshen"],
        ["珠宝玉器", "gem"],
        ["积分商城", "integral"],
        ["帮助中心", "guide"]
      ],
      cartData: [],
      class_id: 0, //分类ID
      iTem: [],
      condata: [],
      condata2: [],
      condata3: [],
      showClassNav: false,
      searchType: ["宝贝", "店铺"],
      search_value: "",
      currentIndex: 0,
      zGoTo: [],
      t: 0,
      keyWords: [],
      currentSearch: "",
      searchTypeRouter: ["/goodsSearch", "/storeSearch"],
      logo_name:'',
    };
  },
  created() {
    this. getFootData();
    //搜索类型
    this.currentSearch = this.$route.query.hasOwnProperty("p")
      ? this.searchType[this.$route.query.p]
      : this.searchType[0];

    this.search_value = this.$route.query.title;

    this.getClass();
    //导航
    this.HTTP(this.$httpConfig.nav, {}, "post", false).then(res => {
      this.items = res.data.data;
      //console.log(this.items);
    }).catch((e)=>{
      console.log(e)
    });
    // shop-sn
    this.$route.query.num === undefined ? this.off=0  : this.off=this.$route.query.num;
  },

  mounted() {
    this.getKeySearchList();
  },
  
  methods: {
    //logo
    getFootData(){
				this.HTTP(this.$httpConfig.aboutEtcetera,{},'post')
				.then((res) =>{
          this.logo_name = res.data.data.logo_name;
          localStorage.setItem('logo_name',this.logo_name);
				}).catch(err=>{
          console.log(err)
        })
		},
    toLink(item,num){
      window.location.href = item.link+'&num='+num;
    },

    //热词搜索(商品搜索)
    hotSearch(value) {
      //console.log(value);
      // return
      this.$router.push({
        path: this.searchTypeRouter[0],
        query: {
          title: value.hot_words,
          class_id: value.goods_class_id,
          types: "hotSearch",
          type:0
        }
      });
    },

    //搜索栏底部关键词
    getKeySearchList() {
      this.HTTP(this.$httpConfig.getKeyWordsList, {}, "post")
        .then(res => {
          this.keyWords = res.data.data;
          //console.log(this.keyWords);
        })
        .catch(e => {
          console.log(e);
        });
    },
    GoTo(item) {
      //sessionStorage.setItem('crumbs',item.class_name)
      this.t++;
      //this.$router.push({path:'/goodsClass',query:{class_id:item.id,id:this.t}})
      window.open(
        window.location.origin +
          "/goodsClass?class_id=" +
          item.id +
          "&id=" +
          this.t +
          "&class_name=" +
          item.class_name
      );
    },
    to(index, url) {
      //console.log(this);
      // let str = url.match(`currentId=${index}`)[0].match(/\d/g)
      //console.log(this.$router.replace(url));
      // ~~str
      // window.open(url)
      // this.currentIndex = index
    },
    handleCommand(command) {
      this.currentSearch = this.searchType[command];

      this.currentIndex = command;
    },
    /**
     * 搜索
     */
    search() {
      if(this.search_value===this.$route.query.title){
        this.$message("页面已加载");
        this.$router.replace({
          path: this.searchTypeRouter[this.currentIndex],
          query: {
            type: this.currentIndex,
            title: this.search_value
          }
        });
      }else{
        this.$router.replace({
          path: this.searchTypeRouter[this.currentIndex],
          query: {
            type: this.currentIndex,
            title: this.search_value
          }
        });
      }
      
      //this.$router.go(0);
    },
    showClass() {
      this.showClassNav = true;
    },
    hideClass() {
      this.showClassNav = false;
    },
    ctrlClass() {
      this.showClassNav = !this.showClassNav;
    },
    mouseover(item, index, once) {
      this.showClassNav = true;
      this.succ(item.id, once);
    },
    getClass() {
      this.HTTP(
        this.$httpConfig.getClass,
        {
          id: this.class_id
        },
        "post"
      )
        .then(res => {
          this.iTem = res.data.data;

          let data = res.data.data;

          let classData = {};
          for (let index = 0; index < data.length; index++) {
            classData[data[index].id] = data[index].class_name;
          }
          localStorage.setItem("class", JSON.stringify(classData));
        })
        .catch(e => {
          console.log(e);
        });
    },
    succ(id, once) {
      this.HTTP(this.$httpConfig.getClass, { id: id }, "post").then(res => {
        //console.log(res);
        //this.zGoTo=res.data
        switch (once) {
          case 1:
            this.condata = res.data.data;
            break;
          case 2:
            this.condata2 = res.data.data;
            break;
          case 3:
            this.condata3 = res.data.data;
            break;
          default:
            break;
        }
      });
    },
    getGoods(goods, index) {
      //console.log(goods, index);
      this.display = null;
    },
    open() {
      this.on = true;
      this.isactive = true;
    },
    close() {
      this.on = null;
      this.isactive = null;
    }
  }
};
</script>
<style lang="less" scoped>

.gp-s:hover {
  color: #e2c670;
}
nav .bottom .navul li .active {
  color: #e2c670;
}

.gp-s {
  color: #666;
  cursor: pointer;
}
.l {
  float: left;
}
.r {
  float: right;
}
.line {
  border-bottom: 2px solid #c79a01;
}
nav {
  width: 1200px;
  height: 156.5px;
  margin: 0 auto;
  .top {
    width: 100%;
    .logo {
      margin-top: 26px;
      float: left;
      width:143px;height: 50px;
    }
    .middle {
      margin: 35px 0 0 132px;
      width: 520px;
      float: left;
      .inp {
        width: 520px;
        height: 34px;
        /*border: 2px solid #b5a069;*/
        float: left;
        padding: 0;
        .dianpu {
          height: 34px;
          width: 68px;
          float: left;
          border-right: 1px solid #ccc;
          line-height: 32px;
          border-bottom: 2px solid #d09d27;
          border-top: 2px solid #d09d27;
          border-left: 2px solid #d09d27;
          span {
            margin-left: 10px;
            cursor: pointer;
          }
          i {
            margin-left: 2px;
          }
        }
        input {
          width: 375px;
          height: 100%;
          border-bottom: 2px solid #d09d27;
          border-top: 2px solid #d09d27;
          border-right: 2px solid #d09d27;
          float: left;
          padding-left: 5px;
        }
        .search {
          width: 75px;
          height: 100%;
          float: left;
          background-color: #d09d27;
          color: #fff;
          text-align: center;
          line-height: 34px;
          cursor: pointer;
        }
      }
      ul {
        float: left;
        margin-top: 8px;
        li {
          float: left;
          margin-right: 14px;
          cursor: pointer;
          a {
            color: #ababab;
          }
          &:hover a {
            color: red;
          }
        }
      }
    }
    .dropdown-content {
      margin-top: 39px;
    }
  }
  .bottom {
    width: 100%;
    margin-top: 14px;
    .all {
      height: 45px;
      width: 210px;
      background: #c79a01;
      line-height: 44px;
      position: relative;
      text-align: center;
      .all-class-ctrl {
        height: 45px;
        width: 210px;
        background: #c79a01;
        line-height: 44px;
        position: relative;
        text-align: center;
        cursor: pointer;
      }
      .jiazai {
        margin: 15px 11px 0 13px;
        float: left;
      }
      span {
        color: #ffffb2;
        font-size: 15px;
        float: left;
      }

      .nav-class {
        width: 1200px;
        height: auto;
        margin: 0 auto;
        z-index: 999;
        display: flex;
        min-height: 407px;
        .allul {
          position: relative;
          width: 210px;
          height: 100%;
          background: rgba(231, 193, 66, 0.9);
          padding-top: 5px;
          float: left;
          z-index: 999999999;
          .li {
            z-index: 999999999;
            height: 33px;
            line-height: 33px;
            position: relative;
            i {
              float: right;
              margin: 13px 25px 0 0;
              color: #fffcda;
            }
            a {
              margin-left: 11px;
              color: #626262;
              float: left;
            }
            img {
              margin-left: 29px;
              float: left;
              margin-top: 11px;
            }
            &:hover {
              background: rgba(255, 255, 255, 0.5);
              border-left: #e3c044 solid 1px;
            }
          }
        }
        .banner-image-box {
          width: 780px;
          height: 407px;
          float: left;
          position: relative;
          cursor: pointer;
          font-size: 11px;
          .allul-child {
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            right: 130px;
            z-index: 999;
            background-color: #fff;
            z-index: 9999;
            .show {
              z-index: 9999;
              background: #fff;
              border: 1px solid rgba(231, 193, 66, 0.9);
              border-right: none;
              overflow: hidden;
              width: 150px;
              float: left;
              height: 407px;
              p {
                font-size: 14px;
                color: #333;
                width: 100%;
                float: left;
              }
              .item {
                font-size: 13px;
                color: #333;
                margin: 5px;
                line-height: 15px;
                width: 100px;
                text-align: center;
              }
              .li-class2 {
                width: 150px;
                overflow: hidden;
                padding-right: 12px;
                padding-left: 10px;
                float: left;
                p {
                  position: relative;
                  height: 36px;
                  line-height: 36px;
                  font-size: 13px;
                  color: #111;
                }
              }
            }
            .show3 {
              height: 407px;
              float: left;
              background-color: #fff;
              z-index: 9999;
              width: 500px;
              border: 1px solid rgba(231, 193, 66, 0.9);
              .li-class3 {
                width: 33.3%;
                text-align: center;
                overflow: hidden;
                padding-right: 12px;
                padding-left: 10px;
                float: left;
                p {
                  position: relative;
                  height: 36px;
                  line-height: 36px;
                  font-size: 12px;
                  color: #626262;
                }
              }
            }
          }
        }
      }
    }

    .navul {
      margin-left: 230px;
      margin-top: 12px;
      li {
        float: left;
        margin-right: 45px;
        a {
          color: #2b2b2b;
          font-size: 16px;
        }
        .router-link-exact-active {
          color: #e2c670 !important;
        }
      }
    }
  }
}
</style>
